import type { Rest } from '@libs/data-access/entities'
import { Modal } from '@libs/ui/ds'
import type { ReduxState } from '@spa/redux/ReduxState'
import type { FC } from 'react'
import React from 'react'
import { useSelector } from 'react-redux'

import { RestCantBeCreated } from '../Alerts'
import { RestSuccessfullyCreated } from '../Alerts/RestSuccessfullyCreated/RestSuccessfullyCreated'

type Props = {
  contractIdsError: number[]
  restsSuccess: Rest[]
}

const FormError: FC<Props> = ({ contractIdsError, restsSuccess }) => {
  const contracts = useSelector((state: ReduxState) =>
    state.contracts.get('data')
  )

  return (
    <div>
      <Modal.Content>
        <RestCantBeCreated
          contracts={contracts}
          contractIdsError={contractIdsError}
        />
        {Boolean(restsSuccess.length) && (
          <RestSuccessfullyCreated
            contracts={contracts}
            restsSuccess={restsSuccess}
          />
        )}
      </Modal.Content>
    </div>
  )
}

export default FormError
